import React from 'react';
import './SubscriptionDashboard.css';

const SubscriptionDashboard = () => {
    return (
        <div className="subscription-dashboard">
            <div className="card">
                <h2>Suscripciones deshabilitadas</h2>
                <p>
                    Por ahora el sistema funciona sin suscripciones ni cobros recurrentes.
                    Puedes usar la plataforma de forma directa con las funcionalidades principales
                    habilitadas.
                </p>
            </div>
        </div>
    );
};

export default SubscriptionDashboard;